export const A11Y_CHILD_MIN_INDEX = 0;
export const A11Y_DEFAULT_CURRENT_INDEX = -1;
